import { render, staticRenderFns } from "./dialog-view-clone.vue?vue&type=template&id=2b76ed7c&scoped=true"
import script from "./dialog-view-clone.vue?vue&type=script&lang=js"
export * from "./dialog-view-clone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b76ed7c",
  null
  
)

export default component.exports